import React from 'react';
import { Card, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ReviewCategoryFilter from './ReviewCategoryFilter';
import ReviewTable from './ReviewTable';

const ReviewFilter = () => {
  return (
    <React.Fragment>
      <Col xl={3} lg={4}>
        <Card className="review-filter">
          <Card.Header>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <h5 className="card-title mb-0">Filters</h5>
              </div>
              <div className="flex-shrink-0">
                <Link to="#" className="text-decoration-underline" id="clearall">Clear All</Link>
              </div>
            </div>
          </Card.Header>

          {/* Review Category Filter */}
          <ReviewCategoryFilter />
        </Card>
      </Col>

      <Col xl={9} lg={8}>
        <ReviewTable />
      </Col>
    </React.Fragment>
  );
};

export default ReviewFilter;
